<script>
import formatDate from '@utils/format-date'
import formatCurrency from "@utils/format-currency";
import  { formatOrder } from "@utils/format-order";
import { merchantComputed } from "@store/helpers";
import { orderIsCanPay, orderIsOffline, orderParamsList } from "@utils/ipetbooking-order";
import formatPrice from "@utils/format-price";
import { conditionList } from "@utils/is-condition";

export default {
  props: {
    pointList: {
      type: Array,
      default: () => {
        return []
      }
    },
    status: {
      type: String,
      default: 'all',
      validator: (val) => ['all', 'earned', 'used'].includes(val),
    },
  },
  data() {
    return {
    }
  },
  computed: {
    ...merchantComputed,
  },
  methods: {
    formatDate,
    formatCurrency,
    goToOrderItem(item) {
      if (item.order_id !== '0')
        this.$router.push({
          name: 'shop-member-shopping-item',
          params: {
            orderId: item.order_id
          }
        })
    },
    formatUsagePeriod({startDate, expireDate}) {
      if (!!startDate && !!expireDate)
        return `${formatDate(startDate, 'yyyy/MM/dd')} - ${formatDate(expireDate, 'yyyy/MM/dd')}`
      if (!!startDate && expireDate === '')
        return `起始日期 ${formatDate(startDate, 'yyyy/MM/dd')} `
      if (startDate === '' && !!expireDate)
        return `即日起至 ${formatDate(expireDate, 'yyyy/MM/dd')}`
      
      return '無限制'
    }
  }
}
</script>
<!-- section template -->
<template>
  <div v-loading="$isLoading('fetchPointList')" element-loading-text="取得捲粉點數中..." :class="$style.pointListSectionList">
    <div class="pointListSectionList__list">
      <div v-for="(point, index) in pointList" :key="index" class="pointListSectionList__item" :class="{ 'isClickable': point.order_id !== '0' }" @click="goToOrderItem(point)">
        <div class="pointListSectionList__leftBox" :class="{ 'isPlus': parseInt(point.amount) > 0 }">
          <div>
            <i class="pointListSectionList__icon fontello fontello-paw fa-fw"></i>
          </div>
          <div class="font-number fw-medium ml-4">{{ `${parseInt(point.amount) > 0 ? '＋' : '－'}${Math.abs(point.amount)}` }}</div>
        </div>
        <div>
          <div class="mb-2">{{ point.action }}</div>
          <div class="pointListSectionList__date font-number">{{ formatDate(point.date_earning, 'yyyy/MM/dd') }}</div>
        </div>
      </div>
    </div>

    <BasePre>pointList: {{ pointList }}</BasePre>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.pointListSectionList {
  min-height: 532px;

  :global {
    .pointListSectionList {
      &__list {
        // padding: 20px 0;
      }

      &__item {
        display: flex;
        align-items: center;
        border-bottom: 1px solid $color-line;
        padding: 25px 0;
        padding-left: 23.5%;

        @include max-md {
          padding-left: 20px;
        }

        &.isClickable {
          cursor: pointer;
          transition: .2s background-color;
          &:hover {
            background-color: #F5F7FA;
          }
        }
      }
      
      &__leftBox {
        display: flex;
        align-items: center;
        width: 200px;

        @include max-md {
          width: 110px;
          margin-right: 1rem;
        }

        &.isPlus {
          color: #BB9A37;
          border-color: #BB9A37;
        }
      }

      &__icon {
        position: relative;
        font-size: 24px;
        width: auto;

        @include max-md {
          font-size: 12px;
        }

        &::after {
          position: absolute;
          content: '';
          width: 42px;
          height: 42px;
          border-radius: 50px;
          border: 1px solid;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);

          @include max-md {
            width: 22px;
            height: 22px;
          }
        }
      }

      &__date {
        color: $color-text;
      }
    }
  }
}

</style>
